import React, { useEffect } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { useSelector } from "react-redux";

var Page401 = function Page401() {
    var loginInProgress = useSelector(function (state) {
        return state.header.auths.loginInProgress;
    });
    var appLoaded = useSelector(function (state) {
        return state.header.app.loaded;
    });
    var location = useLocation();
    var history = useHistory();

    useEffect(function () {
        if (!loginInProgress && appLoaded) {
            history.push({
                pathname: '/login',
                state: {
                    previousPathname: location.pathname
                }
            });
        }
    }, [location.pathname, history, loginInProgress, appLoaded]);

    return null;
};

export default Page401;